export default function Paper(theme) {
  return {
    MuiPaper: {
      styleOverrides: {
        root: {
          border: `1px solid ${theme.vars.palette.grey[200]}`
        }
      }
    }
  };
}
